import { useMutation, useQuery, useQueryClient } from "react-query";
import useApiHelper from "../services/useApiHelper";

export default function useSocialScheduleSingle(socialScheduleId) {
  const staleTime = 1000 * 60;
  const queryClient = useQueryClient();
  const { get, post, put, del } = useApiHelper();

  const socialSchedule = useQuery(
    ["socialSchedules", "single", socialScheduleId],
    () => get(`/socialSchedule/${socialScheduleId}/single`).then((res) => res.data),
    {
      staleTime: staleTime,
      active: !!socialScheduleId
    }
  );

  const addEmptyPost = useMutation(
    (scheduleId) => put(`/socialSchedule/${scheduleId}/emptypostdata`, null),
    {
      onSuccess: () => {
        queryClient.refetchQueries(["socialSchedules"])
      },
    }
  );

  const removeSchedule = useMutation(
    (scheduleId) => del(`/socialSchedule/${scheduleId}`),
    {
      onSuccess: (_, scheduleId) => {
        queryClient.refetchQueries(["socialSchedules"])
      },
    }
  );

  const removePost = useMutation(
    (postId) => del(`/socialSchedule/postdata/${postId}`),
    {
      onSuccess: (_, scheduleId) => {
        queryClient.refetchQueries(["socialSchedules"])
      },
    }
  );


  return {
    socialSchedule,
    addEmptyPost,
    removeSchedule,
    removePost,
  };
}
